import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queries";
import { AuthProvider } from "./lib/auth";
import { AppShell } from "./views/AppShell";
import { LoginView } from "./views/LoginView";
import { PreviewBridge } from "./views/PreviewBridge";
import { HomeView } from "./views/HomeView";
import { TreinosView } from "./views/TreinosView";
import { EvolucaoView } from "./views/EvolucaoView";
import { PerfilView } from "./views/PerfilView";
import { AnamneseView } from "./views/AnamneseView";
import { HistoricoView } from "./views/HistoricoView";
import { WorkoutExecutionView } from "./views/WorkoutExecutionView";
import { DietExecutionView } from "./views/DietExecutionView";
import { NotFoundView } from "./views/NotFoundView";
import { InstallAppPrompt } from "./components/InstallAppPrompt";

/**
 * Raiz da app. As URLs mantêm o prefixo `/s/:slug` em paridade com o portal
 * legado (rotina.bio/s/<slug>), pra os links já enviados aos alunos pelo
 * WhatsApp continuarem válidos. `/s/:slug/login` é público; tudo sob
 * `/s/:slug` passa pela guarda do <AppShell>.
 */
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/s/:slug/login" element={<LoginView />} />
            <Route path="/s/:slug/preview-bridge" element={<PreviewBridge />} />
            <Route path="/s/:slug" element={<AppShell />}>
              <Route index element={<HomeView />} />
              <Route path="treinos" element={<TreinosView />} />
              <Route path="treinos/:executionId" element={<WorkoutExecutionView />} />
              <Route path="dietas/:executionId" element={<DietExecutionView />} />
              <Route path="evolucao" element={<EvolucaoView />} />
              <Route path="historico" element={<HistoricoView />} />
              <Route path="perfil" element={<PerfilView />} />
              <Route path="anamnese" element={<AnamneseView />} />
            </Route>
            <Route path="*" element={<NotFoundView />} />
          </Routes>
          {/* Convite "Instale o app" — fora das rotas pra valer no login e no portal. */}
          <InstallAppPrompt />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export { Navigate };
